import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardImg,
  CardTitle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";

// Core Components

function ResetCard1Blank(props) {
    const [emailFocus, setEmailFocus] = React.useState("");

    if(cardImg) {
        var cardImg = (<CardImg alt="..." src={ props.coverImg }></CardImg>)
    } else {
        var cardImg = (<></>)
    }


  return (
    <>
      <Card className="bg-secondary shadow border-0">
        <CardHeader>
          { cardImg }
          <CardTitle className="text-center g-font-kanit" tag="h4">
            {props.title}
          </CardTitle>
        </CardHeader>
        <CardBody className="p-2">
          {props.body}
        </CardBody>
      </Card>
    </>
  );
}

export default ResetCard1Blank;
